<template>
  <div class="filter-min-max">
    <div class="filter-label" @click="showOptions = !showOptions">
      {{ valueLabel }}
    </div>
    <div
      class="filter-options"
      v-if="showOptions"
      v-click-outside="clickedOutsideOptions"
    >
      <div class="fields">
        <div class="field">
          <label>{{ t('automations-form-filters-period_between_executions-label') }}:</label>
          <input type="tel" v-model="number" v-mask="options.mask" />
        </div>
        <div class="radio-holder">
          <label>{{ t('automations-form-filters-period_between_executions-check_label') }} </label>
          <div>
            <label
              ><input type="radio" v-model="check" value="this" />
              <small>{{ t('automations-form-filters-period_between_executions-check_options-this') }}</small></label
            >
          </div>
          <div>
            <label
              ><input type="radio" v-model="check" value="all" />
              <small>{{ t('automations-form-filters-period_between_executions-check_options-all') }}</small></label
            >
          </div>
        </div>
      </div>
      <div class="filter-actions">
        <button
          type="button"
          class="cancelBtn btn btn-sm btn-default"
          @click="cancel"
        >
          {{ t('automations-form-filters-period_between_executions-close_button') }}
        </button>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.field {
  display: flex;
  label {
    width: auto;
    display: block;
    margin-right: 10px;
  }
}

.radio-holder {
  label {
    margin-top: 0;
  }
}
input[type="tel"] {
  border: none;
  border-bottom: 1px solid #ddd;
  box-shadow: none;
  font-size: 13px;
  flex-grow: 1;
  width: 100%;
  &:focus {
    outline: none;
    box-shadow: none;
    border: none;
    border-bottom: 1px solid #ddd;
  }
}
</style>
<script>
export default {
  name: "min-period-between-execution",
  props: {
    name: {
      type: String,
      default: "number",
    },
    currentValue: {
      type: Object,
      default: () => ({
        number: null,
        check: "this",
      }),
    }
  },
  data() {
    return {
      showOptions: false,
      clickedOutsideOptions: () => {},
      value: "",
      changedValue: false,
      number: null,
      check: "this",
      options: {
        mask: "#####",
        label: this.t('automations-form-filters-period_between_executions-label'),
        suffix: this.t('automations-form-filters-period_between_executions-suffix'),
      },
    };
  },
  mounted() {
    if (this.currentValue && Object.keys(this.currentValue).length > 0) {
      let value = this.currentValue;
      this.number = value.number;
      this.check = value.check;
      this.setValue();   
      this.changed();
    }
  },
  methods: {
    t(term, replaces) {
      return this.$root.t(term, replaces);
    },
    cancel() {
      this.showOptions = false;
    },
    changed() {
      this.$emit("changed", this.value);
    },
    setValue() {
      this.value = {
        number: this.number,
        check: this.check,
      };
    },
  },
  computed: {
    suffix() {
      return " " + this.t('automations-form-filters-period_between_executions-suffix');
    },
    valueLabel() {
      const check = this.check === "all" ? this.t('automations-form-filters-period_between_executions-check_suffix-all') : this.t('automations-form-filters-period_between_executions-check_suffix-this');
      return this.number ? this.number + this.suffix + check : this.t('automations-form-filters-period_between_executions-not_informed');
    },
  },
  watch: {
    showOptions() {
      if (this.showOptions) {
        window.setTimeout(() => {
          this.clickedOutsideOptions = () => {
            if (this.showOptions) {
              this.cancel();
            }
          };
        }, 100);
      } else {
        this.setValue();
        this.clickedOutsideOptions = () => {};
      }
    },
    value() {
      this.changed();
    },
  },
};
</script>
